import { useEffect } from "react";

import { $isLinkNode, LinkNode } from "@lexical/link";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $getNodeByKey } from "lexical";

import type { RTEComponentDefs } from "../RichTextEditorProps";

export interface CollectLinksPluginDefs {
  readonly onLinkFound: (url: string) => void;
}

export const CollectLinksPlugin: RTEComponentDefs<CollectLinksPluginDefs> = ({ onLinkFound }) => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return editor.registerMutationListener(
      LinkNode,
      (mutations) => {
        for (const [key, mutation] of mutations) {
          if (mutation === "destroyed") continue;
          const url = editor.read(() => {
            const node = $getNodeByKey(key);
            return $isLinkNode(node) ? node.getURL() : null;
          });
          if (url != null) onLinkFound(url);
        }
      },
      { skipInitialization: false },
    );
  }, [editor, onLinkFound]);

  return null;
};
